import { type SidebarComponent } from '@tunasong/ui-lib'
import type { FC } from 'react'
import ReactJson from 'react-json-view'

export const SidebarEntity: FC<SidebarComponent> = ({ entity }) => <ReactJson src={entity as object} theme="monokai" />
